module.exports = __webpack_public_path__ + "static/media/leadership-edition-2024-social-image.30c4a2ae.jpg";